<div class="route-plan" data-testid="route-plan-container" [hidden]="loadingMap || noRoute">
  @for (routePlanEl of routeData?.RoutePlan; track routePlanEl; let i = $index) {
  <div class="route-element-outer" [attr.data-testid]="'route-plan-item-' + i" (click)="onRoutePlanClick(routePlanEl, i)"
    [class.active]="activePlanningPanelRouteElement==i">

    @if (i!=0) {
    <div class="route-el-divider">
      <div class="divider-line-wrap">
        <div class="divider-line"></div>
      </div>
      <div class="distance-chip">
        <svg class="distance-chip-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 8h12M8 3l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        @if (settingsService.getUnit().Distance == 'metric') {
        <span>{{ (routePlanEl.DistanceFromPreviousElement ?? 0) | turnValueIntegerThousands }} km</span>
        }
        @if (settingsService.getUnit().Distance == 'imperial') {
        <span>{{ (routePlanEl.DistanceFromPreviousElement ?? 0)*0.621371192 | turnValueIntegerThousands }} mi</span>
        }
      </div>
    </div>
    }

    <!-- CARD -->
    <div class="re-card" [class.re-card--charger]="routePlanEl.Type==RoutePlanType.Charger || routePlanEl.Type==RoutePlanType.ChargerEndPoint">

      <!-- LEFT: type icon badge -->
      <div class="re-badge"
        [class.re-badge--start]="routePlanEl.Type==RoutePlanType.StartPoint"
        [class.re-badge--end]="routePlanEl.Type==RoutePlanType.EndPoint"
        [class.re-badge--waypoint]="routePlanEl.Type==RoutePlanType.WayPoint"
        [class.re-badge--charger]="routePlanEl.Type==RoutePlanType.Charger || routePlanEl.Type==RoutePlanType.ChargerEndPoint"
        [class.re-badge--warning]="routePlanEl.BatteryReservedWarning"
        [attr.data-testid]="'route-plan-badge-' + i"
        (click)="routePlanEl.BatteryReservedWarning ? openBatteryReservedSnackbar() : $event.stopPropagation()">

        @if (routePlanEl.Type==RoutePlanType.StartPoint) {
        <!-- Flag / start -->
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 21V4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <path d="M5 4h11l-3 4.5 3 4.5H5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="currentColor" fill-opacity="1"/>
        </svg>
        }
        @if (routePlanEl.Type==RoutePlanType.EndPoint) {
        <!-- Checkered flag / target -->
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="10" r="6" stroke="currentColor" stroke-width="2"/>
          <circle cx="12" cy="10" r="2.5" fill="currentColor"/>
          <line x1="12" y1="16" x2="12" y2="22" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        }
        @if (routePlanEl.Type==RoutePlanType.WayPoint) {
        <!-- Waypoint number -->
        <span class="re-badge-number">{{ routePlanEl.WaypointIndex }}</span>
        }
        @if (routePlanEl.Type==RoutePlanType.Charger) {
        <!-- Lightning bolt + number -->
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13 2L4.5 13.5H12L11 22L19.5 10.5H12L13 2Z" fill="currentColor" stroke="currentColor" stroke-width="1" stroke-linejoin="round"/>
        </svg>
        <span class="re-badge-charger-index">{{ (routePlanEl.ChargerIndex ?? 0) + 1 }}</span>
        }
        @if (routePlanEl.Type==RoutePlanType.ChargerEndPoint) {
        <!-- Lightning bolt at destination -->
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13 2L4.5 13.5H12L11 22L19.5 10.5H12L13 2Z" fill="currentColor" stroke="currentColor" stroke-width="1" stroke-linejoin="round"/>
        </svg>
        <svg class="re-badge-target" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
          <circle class="re-badge-target-bg" cx="6" cy="6" r="6"/>
          <circle class="re-badge-target-ring" cx="6" cy="6" r="4.25"/>
          <circle class="re-badge-target-dot" cx="6" cy="6" r="1.75"/>
        </svg>
        }
      </div>

      <!-- RIGHT: content -->
      <div class="re-content">

        <!-- Name + operator row -->
        <div class="re-name">{{ routePlanEl.Name }}@if (routePlanEl.OperatorName) { / <span class="re-operator">{{ routePlanEl.OperatorName }}</span>}</div>

        <!-- Battery / charging section -->
        <!-- Battery indicator row -->
        <div class="re-battery-row">

          @if (routePlanEl.Type==RoutePlanType.Charger || routePlanEl.Type==RoutePlanType.ChargerEndPoint) {
          <!-- Charger: arrival % → departure % + charge time -->
          <div class="re-battery-widget re-battery-widget--charge">
            <!-- arrival battery -->
            <svg class="re-bat-icon" viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.75" y="0.75" width="24.5" height="12.5" rx="2.25" stroke="currentColor" stroke-width="1.5"/>
              <path d="M26.5 4.5v5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              <rect class="re-bat-fill" x="2" y="2" height="10" [attr.width]="(routePlanEl.BatteryMinPercent ?? 0) * 0.22" rx="1.25"/>
            </svg>
            <span class="re-bat-pct">{{ routePlanEl.BatteryMinPercent }}%</span>
            <!-- arrow -->
            <svg class="re-bat-arrow" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 5h12M9 1l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <!-- departure battery -->
            <svg class="re-bat-icon" viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.75" y="0.75" width="24.5" height="12.5" rx="2.25" stroke="currentColor" stroke-width="1.5"/>
              <path d="M26.5 4.5v5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              <rect class="re-bat-fill re-bat-fill--charged" x="2" y="2" height="10" [attr.width]="(routePlanEl.BatteryMaxPercent ?? 0) * 0.22" rx="1.25"/>
            </svg>
            <span class="re-bat-pct re-bat-pct--charged">{{ routePlanEl.BatteryMaxPercent }}%</span>
          </div>
          <!-- charge time -->
          <div class="re-charge-time">
            <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="8" cy="8" r="6.25" stroke="currentColor" stroke-width="1.5"/>
              <path d="M8 5v3.5l2 1.2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>{{ getChargeTime(routePlanEl.ChargeTimeHour ?? 0, routePlanEl.ChargeTimeMin ?? 0) }}</span>
          </div>
          <!-- plug type -->
          <div class="re-charge-time">
            <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 2v3M5 2v3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              <rect x="3.5" y="5" width="6" height="3.5" rx="1" stroke="currentColor" stroke-width="1.5"/>
              <path d="M6.5 8.5V12a1.5 1.5 0 0 0 3 0V8.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            <span>{{ getPlugLabel(routePlanEl.Icon) }}@if (routePlanEl.ChargePower) { &middot; {{ routePlanEl.ChargePower }} kW}</span>
          </div>
          }

          @if (routePlanEl.Type!=RoutePlanType.Charger && routePlanEl.Type!=RoutePlanType.ChargerEndPoint) {
          <!-- Non-charger: single battery level -->
          <div class="re-battery-widget">
            <svg class="re-bat-icon" viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.75" y="0.75" width="24.5" height="12.5" rx="2.25" stroke="currentColor" stroke-width="1.5"/>
              <path d="M26.5 4.5v5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              <rect class="re-bat-fill" x="2" y="2" height="10" [attr.width]="$any(routePlanEl).BatteryLevel * 0.22" rx="1.25"/>
            </svg>
            <span class="re-bat-pct">{{ $any(routePlanEl).BatteryLevel }}%</span>
          </div>
          }

          @if (routePlanEl.WeatherImg) {
          <!-- Weather chip: the SVG is inlined so its strokes follow the theme colour like the clock / plug icons -->
          <div class="re-weather" role="img" aria-label="weather" data-testid="route-plan-weather-chip">
            <span [appSvgRecolor]="'assets/icons/default/weather/' + routePlanEl.WeatherImg"></span>
          </div>
          }
        </div>

      </div>
    </div>
  </div>
  }
</div>
